exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#mainNav{font-family:Nunito,sans-serif}#mainNav .nav-item .active,#mainNav .nav-item :hover{color:#fbc531;text-decoration:none;cursor:pointer}.navbar-default{transition:.5s ease;background:transparent}.navbar-default.scrolled{-webkit-box-shadow:0 .5rem 1rem rgba(0,0,0,.15);box-shadow:0 .5rem 1rem rgba(0,0,0,.15);background-color:rgba(26,26,26,.8)}.navbar-dark .navbar-nav .nav-link{color:hsla(0,0%,100%,.8)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./src/components/Navbar/navbar.scss
// module id = 161
// module chunks = 0